export const DEFAULT_SECTION = {
  Name: '',
  Weight: 0,
  Index: 0,
  ParentIndex: -1,
  Visible: true,
  Style: 'default',
  Layout: {
    useCol: true,
    s: 12,
    m: 12,
    l: 12,
    xl: 12,
    pushS: 0,
    pushM: 0,
    pushL: 0,
    pushXL: 0,
    pullS: 0,
    pullM: 0,
    pullL: 0,
    pullXL: 0,
    offsetS: 0,
    offsetM: 0,
    offsetL: 0,
    offsetXL: 0,
    useRow: false,
    Section: 0,
    showDescr: false,
    visible: true,
    descrPopup: false
  },
  FormLayout: {
    useCol: true,
    s: 12,
    m: 12,
    l: 12,
    xl: 12,
    pushS: 0,
    pushM: 0,
    pushL: 0,
    pushXL: 0,
    pullS: 0,
    pullM: 0,
    pullL: 0,
    pullXL: 0,
    offsetS: 0,
    offsetM: 0,
    offsetL: 0,
    offsetXL: 0,
    useRow: false,
    Section: 0,
    showDescr: false,
    visible: true,
    descrPopup: false
  },
  Widgets: null
}
